/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ratio: NonNullable<unknown> }} Audio_Description_Export_Automix_Ratio_HelpInputs */

const en_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compression ratio (1:${i?.ratio}) - higher means more ducking`)
};

const fr_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ratio de compression (1:${i?.ratio}) - plus élevé = plus d'atténuation`)
};

const de_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kompressionsverhältnis (1:${i?.ratio}) – ein höherer Wert bedeutet stärkeres Ducking`)
};

const it_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rapporto di compressione (1:${i?.ratio}) - più alto significa più ducking`)
};

const ru_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Степень сжатия (1:PH0) — чем выше, тем больше демпфирование.`)
};

const es_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Relación de compresión (1:${i?.ratio}): más alta significa más atenuación`)
};

const zh_cn2_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`压缩比 (1:${i?.ratio}) - 越高，意味着更多的下潜`)
};

const ja_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`圧縮比（1:${i?.ratio}） - 高いほどダッキングが多くなります`)
};

const hi_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`संपीड़न अनुपात (1:${i?.ratio}) - उच्च अनुपात का अर्थ है अधिक झुकना`)
};

const pt_pt2_audio_description_export_automix_ratio_help = /** @type {(inputs: Audio_Description_Export_Automix_Ratio_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taxa de compressão (1:${i?.ratio}) - quanto maior, mais abaixamento.`)
};

/**
* | output |
* | --- |
* | "Compression ratio (1:{ratio}) - higher means more ducking" |
*
* @param {Audio_Description_Export_Automix_Ratio_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_ratio_help = /** @type {((inputs: Audio_Description_Export_Automix_Ratio_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Ratio_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_ratio_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_ratio_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_ratio_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_ratio_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_ratio_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_ratio_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_ratio_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_ratio_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_ratio_help(inputs)
	return en_audio_description_export_automix_ratio_help(inputs)
});